import { render, staticRenderFns } from "./ProjectRisk.vue?vue&type=template&id=9f00c3ba&scoped=true&"
import script from "./ProjectRisk.vue?vue&type=script&lang=js&"
export * from "./ProjectRisk.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRisk.vue?vue&type=style&index=0&id=9f00c3ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f00c3ba",
  null
  
)

export default component.exports